import * as actionTypes from '../../../../models/actionTypes';
import { AutoSuggestResult, AutoSuggestResultV2 } from '../../../../models/apiModels';
import { ClientPromptForLoginState } from '../../../../utilities';
import { Region } from '../../models/modalityModels';

export const formSubmission = (query: string) => {
  return {
    type: actionTypes.FETCH_ON_SESSION_START,
    query,
  };
};

export const setContactSearchedQueryText = (query: string, isAutoSuggestQuery: boolean) => {
  return {
    type: actionTypes.SET_CONTACT_SEARCHED_QUERY_TEXT,
    query,
    isAutoSuggestQuery,
  };
};

export const updateSignIn = (clientPromptForLoginState: ClientPromptForLoginState) => {
  return {
    type: actionTypes.UPDATE_SIGN_IN,
    clientPromptForLoginState,
  };
};

export const updateRequestVerificationToken = (formToken: string) => {
  return {
    type: actionTypes.FETCH_CSRF_FORM_TOKEN_SUCCESS,
    formToken,
  };
};

export const setIsAutoSuggestCardSearch = (isAutoSuggestCardSearch: boolean, autoSuggestResults?: AutoSuggestResult[]) => {
  return {
    type: actionTypes.SET_IS_AUTOSUGGEST_CARD_SEARCH,
    isAutoSuggestCardSearch,
    autoSuggestCardResults: autoSuggestResults,
  };
};

export const setIsAutoSuggestCardSearchV2 = (isAutoSuggestCardSearch: boolean, autoSuggestResultsV2?: AutoSuggestResultV2) => {
  return {
    type: actionTypes.SET_IS_AUTOSUGGEST_CARD_SEARCH_V2,
    isAutoSuggestCardSearch,
    autoSuggestCardResultsV2: autoSuggestResultsV2,
  };
};

export const fetchRegionInfo = () => {
  return {
    type: actionTypes.FETCH_REGION_INFO,
  };
};

export const fetchRegionInfoSuccess = (response: Array<Region>) => {
  return {
    type: actionTypes.FETCH_REGION_INFO_SUCCESS,
    response,
  };
};

export const fetchRegionInfoError = () => {
  return {
    type: actionTypes.FETCH_REGION_INFO_ERROR,
  };
};

export const showCoachmark = () => {
  return {
    type: actionTypes.TOGGLE_COACHMARK,
    isFeedbackCoachmarkShowing: true,
  };
};

export const hideCoachmark = () => {
  return {
    type: actionTypes.TOGGLE_COACHMARK,
    isFeedbackCoachmarkShowing: false,
  };
};
